import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/WhatIsIGBTModuleHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-IGBT4.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .wigm { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .wigm-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .wigm-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .wigm-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .wigm-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .wigm-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .wigm-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .wigm-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .wigm-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .wigm-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .wigm-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .wigm-bc-item:hover { color: #EB2019; }
  .wigm-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .wigm-bc-sep img { width: 24px; height: 24px; display: block; }
  .wigm-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .wigm-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .wigm-main-section { padding: 80px 0 120px 0; }
  .wigm-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .wigm-article { flex: 1; min-width: 0; }

  .wigm-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .wigm-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .wigm-meta-item:last-child { border-right: none; padding-right: 0; }
  .wigm-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .wigm-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 20px;
  }

  .wigm-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .wigm-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .wigm-article-body p { margin-bottom: 20px; }
  .wigm-article-body p:last-child { margin-bottom: 0; }

  .wigm-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }
  .wigm-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet ul list */
  .wigm-article-body ul {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .wigm-article-body ul li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .wigm-article-body ul li::before {
    content: '•';
    font-weight: 700; color: #202020;
    flex-shrink: 0; font-size: 18px; line-height: 160%;
  }
  .wigm-article-body ul li > span { flex: 1; }

  /* Numbered ol list — counter style */
  .wigm-article-body ol {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: wigm-counter;
  }
  .wigm-article-body ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: wigm-counter;
  }
  .wigm-article-body ol li::before {
    content: counter(wigm-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .wigm-article-body ol li > span { flex: 1; }

  /* Applications indented ol — no counter, just bold + body */
  .wigm-app-ol {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: wigm-app-counter;
  }
  .wigm-app-ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: wigm-app-counter;
  }
  .wigm-app-ol li::before {
    content: counter(wigm-app-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .wigm-app-ol li > span { flex: 1; }

  .wigm-article-body strong { font-weight: 600; color: #202020; }

  /* Product specs table */
  .wigm-table-wrapper {
    width: 100%; overflow-x: auto; margin: 20px 0 30px 0;
  }
  .wigm-table {
    width: 100%; border-collapse: collapse;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; color: #202020;
  }
  .wigm-table th, .wigm-table td {
    border: 1px solid #B8B8B8;
    padding: 20px 30px;
    text-align: left;
    line-height: 120%;
  }
  .wigm-table th {
    font-weight: 600; background: #F6F6F6;
  }
  .wigm-table td { font-weight: 400; }
  .wigm-table tbody tr:nth-child(odd)  { background-color: #ffffff; }
  .wigm-table tbody tr:nth-child(even) { background-color: #F6F6F6; }

  .wigm-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .wigm-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .wigm-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .wigm-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .wigm-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .wigm-nav-btn:hover { color: #EB2019; }
  .wigm-nav-btn img { width: 40px; height: 40px; display: block; }

  .wigm-share-icons { display: flex; align-items: center; gap: 20px; }
  .wigm-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .wigm-share-icon:hover { opacity: 0.85; }
  .wigm-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .wigm-sidebar { flex: 0 0 475px; }
  .wigm-sidebar-block { margin-bottom: 60px; }
  .wigm-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .wigm-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .wigm-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .wigm-recent-item:hover .wigm-recent-title { color: #EB2019; }
  .wigm-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .wigm-recent-body { flex: 1; min-width: 0; }
  .wigm-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .wigm-social-icons { display: flex; align-items: center; gap: 30px; }
  .wigm-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .wigm-social-icon:hover { opacity: 0.8; }
  .wigm-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .wigm-hero             { height: 350px; }
    .wigm-hero-content     { padding: 0 32px; }
    .wigm-hero-title       { font-size: 30px; }
    .wigm-hero-divider     { width: 100%; max-width: 575px; }
    .wigm-breadcrumb       { padding: 24px 0 0 0; }
    .wigm-breadcrumb-inner { padding: 0 32px; }
    .wigm-inner            { padding: 0 32px; }
    .wigm-main-section     { padding: 48px 0 60px 0; }
    .wigm-main-row         { flex-direction: column; gap: 48px; }
    .wigm-sidebar          { flex: none; width: 100%; }
    .wigm-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .wigm-hero             { height: 360px; }
    .wigm-hero-content     { padding: 0 16px; }
    .wigm-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .wigm-hero-divider     { width: 100%; }
    .wigm-hero-subtitle    { font-size: 14px; }
    .wigm-breadcrumb       { padding: 30px 0 0 0; }
    .wigm-breadcrumb-inner { padding: 0 16px; }
    .wigm-bc-item          { font-size: 14px; gap: 14px; }
    .wigm-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .wigm-bc-sep img       { width: 22px; height: 22px; }
    .wigm-inner            { padding: 0 16px; }
    .wigm-main-section     { padding: 30px 0 60px 0; }
    .wigm-main-row         { flex-direction: column; gap: 60px; }
    .wigm-sidebar          { flex: none; width: 100%; }
    .wigm-article-title    { font-size: 20px; margin-bottom: 15px; }
    .wigm-article-body     { font-size: 14px; }
    .wigm-article-body p   { margin-bottom: 15px; }
    .wigm-article-body ul  { margin: 20px 0 20px 0; gap: 10px; }
    .wigm-article-body ul li { font-size: 14px; }
    .wigm-article-body ol  { margin: 20px 0 20px 0; gap: 20px; }
    .wigm-article-body ol li { font-size: 14px; }
    .wigm-app-ol li        { font-size: 14px; }
    .wigm-article-body strong { font-size: 16px; }
    .wigm-table            { font-size: 12px; }
    .wigm-table th, .wigm-table td { padding: 33px 8px; }
    .wigm-meta-item        { font-size: 14px; }
    .wigm-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .wigm-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .wigm-h2               { font-size: 16px; margin: 20px 0 0px 0; }
    .wigm-heading          { font-size: 16px; margin: 30px 0 15px 0; }
    .wigm-nav-btn img      { width: 24px; height: 24px; }
    .wigm-nav-btn          { font-size: 14px; }
    .wigm-share-icon img   { width: 34px; height: 34px; }
    .wigm-sidebar-title    { font-size: 20px; }
    .wigm-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function WhatIsIGBTModule() {
  return (
    <div className="wigm">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="wigm-hero">
        <img className="wigm-hero-bg" src={HeroBgImg} alt="What is IGBT Module Hero" />
        <div className="wigm-hero-overlay" />
        <div className="wigm-hero-content">
          <h1 className="wigm-hero-title">
            What is IGBT Module?
          </h1>
          <hr className="wigm-hero-divider" />
          <p className="wigm-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="wigm-breadcrumb" aria-label="Breadcrumb">
        <div className="wigm-breadcrumb-inner">
          <a href="/" className="wigm-bc-item">Home</a>
          <span className="wigm-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="wigm-bc-item">News &amp; Updates</a>
          <span className="wigm-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="wigm-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="wigm-main-section">
        <div className="wigm-inner">
          <div className="wigm-main-row">

            {/* ── ARTICLE ── */}
            <article className="wigm-article">

              {/* Meta bar */}
              <div className="wigm-meta-bar">
                <span className="wigm-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="wigm-meta-item"><img src={CalendarIcon} alt="date" /> June 5, 2025</span>
                <span className="wigm-meta-item"><img src={ClockIconImg} alt="time" /> 9:03 am</span>
                <span className="wigm-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="wigm-article-title">
                What is IGBT Module?
              </h1>

              {/* Body */}
              <div className="wigm-article-body">

                <p>An <a href="/igbt-module" className="wigm-red-link-plain">IGBT Module (Insulated Gate Bipolar Transistor Module)</a> is a power electronic device used to switch and control large amounts of current and voltage. It combines the ease of control of a MOSFET with the high-current and low-saturation-voltage capability of a bipolar transistor. These modules are the backbone of many high-efficiency and high-speed switching applications. It is essentially a package that contains multiple IGBT devices and freewheeling diodes integrated into a single compact unit. These are engineered for high-efficiency power control and switching.</p>

                {/* Article image */}
                <img className="wigm-article-img" src={ArticleImg} alt="What is IGBT Module" />

                <p>IGBTs (Insulated Gate Bipolar Transistors) combine the easy gate-drive characteristics of a field effect transistor (MOSFET) with the high current and low saturation voltage capabilities of a bipolar junction transistor (BJT). This hybrid nature makes them a go-to choice in power electronics, especially in high-power and high-voltage applications such as switch mode power supplies, motor drives, and industrial inverters. Compared to standard power MOSFETs, IGBTs offer better performance at higher voltages due to their superior reverse breakdown voltage and ability to handle larger currents efficiently.</p>

                <p>Modern IGBT modules often incorporate asymmetrical IGBTs and punch-through IGBT designs to optimize switching speeds and reduce losses during operation. Their high input impedance simplifies control, while their behavior when reverse biased aligns with the key characteristics of a bipolar transistor. These semiconductor switching devices are essential in PWM (pulse width modulation) systems, enabling precise and efficient energy conversion in a range of power semiconductor applications.</p>

                <span className="wigm-heading">Key reasons IGBT modules are essential:</span>

                <ul>
                  <li><span><strong>Efficient Power Conversion</strong>: Converts DC to AC and vice versa, vital for applications like solar inverters and motor drives.</span></li>
                  <li><span><strong>Compact Design</strong>: Integrated modules save space, reducing design complexity.</span></li>
                  <li><span><strong>High Voltage &amp; Current Handling</strong>: Suitable for high-power operations.</span></li>
                  <li><span><strong>Thermal Management</strong>: Built-in features to handle heat better than discrete IGBTs.</span></li>
                  <li><span><strong>Enhanced Reliability</strong>: Lower failure rate due to integrated protections.</span></li>
                </ul>

                <p>Whether you're working with a wind turbine or an electric car, IGBT modules help drive performance and efficiency.</p>

                <span className="wigm-heading">Key Components Inside an IGBT Module:</span>

                <ul>
                  <li><span><strong>IGBT Chips:</strong> The core switching elements.</span></li>
                  <li><span><strong>Freewheeling Diodes:</strong> Allow for smooth current flow during off states.</span></li>
                  <li><span><strong>Gate Driver Circuitry:</strong> Controls the switching operations.</span></li>
                  <li><span><strong>Thermal Interface Material:</strong> Aids heat dissipation.</span></li>
                  <li><span><strong>Substrate and Baseplate:</strong> Support structure and thermal conduction.</span></li>
                </ul>

                <span className="wigm-heading">These modules are commonly found in:</span>

                <ul>
                  <li><span>Electric and hybrid vehicles (EV/HEV)</span></li>
                  <li><span>Solar inverters</span></li>
                  <li><span>UPS systems</span></li>
                  <li><span>Railway traction</span></li>
                  <li><span>Industrial motor drives</span></li>
                  <li><span>Wind turbines</span></li>
                </ul>

                <span className="wigm-heading">How Do IGBT Modules Work?</span>

                <p>An <a href="/igbt-module" className="wigm-red-link-plain">IGBT module</a> operates as a high-speed switch. When a voltage is applied to the gate terminal, it allows current to flow between the collector and emitter. Its ability to handle high voltage and current, along with fast switching speeds, makes it highly suitable for modern electronic applications.</p>

                <p>Here's a simplified breakdown:</p>

                <ol>
                  <li><span><strong>Gate Voltage Applied</strong> → Channel forms in IGBT → Current flows.</span></li>
                  <li><span><strong>Gate Voltage Removed</strong> → Channel closes → Current stops.</span></li>
                </ol>

                <p>Unlike simple IGBTs, the module contains everything you need to operate it efficiently in high-load environments, including protection and thermal management features.</p>

                <span className="wigm-heading">Advantages of IGBT Modules</span>

                <ol>
                  <li><span><strong>Compact Design:</strong> Fewer components mean less space and lower overall system cost.</span></li>
                  <li><span><strong>Improved Thermal Performance:</strong> Integrated thermal paths and sensors reduce overheating.</span></li>
                  <li><span><strong>Reliable Operation:</strong> Built-in protection mechanisms like short-circuit, over-temperature, and over-voltage protection.</span></li>
                  <li><span><strong>Ease of Integration:</strong> Pre-packaged and standardized modules are easier to deploy.</span></li>
                  <li><span><strong>Lower EMI:</strong> Designed to reduce electromagnetic interference, improving system robustness.</span></li>
                </ol>

                <span className="wigm-heading">Applications in Detail</span>

                <p>Let's look at some real-world scenarios where IGBT modules play a critical role:</p>

                <ol className="wigm-app-ol">
                  <li><span><strong>Electric Vehicles (EVs)</strong><br />
                  IGBT modules are used in the inverter section to convert the battery's DC power to AC for the traction motor. Their efficiency directly impacts the vehicle's range and performance.</span></li>
                  <li><span><strong>Solar Power Inverters</strong><br />
                  They help convert DC from solar panels to AC for grid or household use. Their high voltage handling and efficiency are ideal for maximum power point tracking (MPPT).</span></li>
                  <li><span><strong>Wind Turbines</strong><br />
                  High reliability and robustness are needed due to variable wind conditions. IGBT modules manage power conversion with minimal losses.</span></li>
                  <li><span><strong>Industrial Motor Drives</strong><br />
                  In factory automation and robotics, IGBT modules allow for precise speed and torque control in large motors.</span></li>
                  <li><span><strong>Railway Systems</strong><br />
                  Used in traction converters and regenerative braking systems, IGBT modules help improve efficiency and reduce heat buildup in locomotives.</span></li>
                </ol>

                <span className="wigm-heading">Product Specifications</span>

                <div className="wigm-table-wrapper">
                  <table className="wigm-table">
                    <thead>
                      <tr>
                        <th>Specification</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Category</td>
                        <td>Conventional</td>
                      </tr>
                      <tr>
                        <td>Controller Model</td>
                        <td>Precicon S</td>
                      </tr>
                      <tr>
                        <td>HMI (Human-Machine Interface)</td>
                        <td>Includes HMI; One HMI Can Operate Up To 30 Controllers; IP54 Protection</td>
                      </tr>
                      <tr>
                        <td>Technology</td>
                        <td>IGBT-Based</td>
                      </tr>
                      <tr>
                        <td>Input Phase</td>
                        <td>3-Phase</td>
                      </tr>
                      <tr>
                        <td>Output Phase</td>
                        <td>1-Phase (Line-To-Line)</td>
                      </tr>
                      <tr>
                        <td>Line Frequency</td>
                        <td>50/60 Hz</td>
                      </tr>
                      <tr>
                        <td>Input Voltage</td>
                        <td>380–480 VAC (L–L)</td>
                      </tr>
                      <tr>
                        <td>Output Voltage</td>
                        <td>As Per Rated Transformer (TR)</td>
                      </tr>
                      <tr>
                        <td>Controller Input Supply</td>
                        <td>110 VAC, −10% / +10%, 50/60 Hz</td>
                      </tr>
                      <tr>
                        <td>Number Of Input Signals</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>Number Of Output Signals</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>Output Signal Protection</td>
                        <td>Galvanic Isolation</td>
                      </tr>
                      <tr>
                        <td>Output Resistance</td>
                        <td>Maximum 750 Ω</td>
                      </tr>
                      <tr>
                        <td>Communication Protocol</td>
                        <td>CAN Bus</td>
                      </tr>
                      <tr>
                        <td>In-Built Rapper Control</td>
                        <td>Controls Up To 4 Rappers</td>
                      </tr>
                      <tr>
                        <td>Remote Monitoring</td>
                        <td>Data Can Be Monitored Via DCS With DCSIM Gateway</td>
                      </tr>
                      <tr>
                        <td>Operating Ambient Temperature</td>
                        <td>Up To 50 °C</td>
                      </tr>
                      <tr>
                        <td>Humidity Tolerance</td>
                        <td>Up To 95% (Non-Condensing)</td>
                      </tr>
                      <tr>
                        <td>Certifications / Approvals</td>
                        <td>CE, CSA</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span className="wigm-heading">Frequently Asked Questions (FAQs)</span>

                <span className="wigm-h2">1. What is the main advantage of using an IGBT module over a discrete IGBT?</span>

                <p><strong>Answer:</strong> IGBT modules integrate multiple IGBTs and diodes into a single compact package, offering better thermal performance, built-in protections, and simplified system design. They save board space, reduce wiring complexity, and improve system reliability compared to using discrete components.</p>

                <span className="wigm-h2">2. Can IGBT modules be used in low-voltage applications?</span>

                <p><strong>Answer:</strong> While IGBT modules are best suited for medium to high-voltage applications, there are low-voltage modules (600V–1200V) available for use in applications like appliances, small inverters, and some battery-powered systems. For very low-voltage, high-speed switching, MOSFETs might be more appropriate.</p>

                <span className="wigm-h2">3. How do I ensure proper cooling for an IGBT module?</span>

                <p><strong>Answer:</strong> Proper cooling can be achieved through heatsinks, forced-air cooling, or liquid cooling systems depending on the power levels. Most IGBT modules come with thermal specifications and recommended cooling methods. Thermal interface materials (TIMs) should be used between the module and heatsink to enhance heat transfer.</p>

                <span className="wigm-h2">4. What causes an IGBT module to fail, and how can I prevent it?</span>

                <p><strong>Answer:</strong> Common causes of failure include over-voltage, over-current, excessive temperature, and poor gate drive control. To prevent these, always:</p>

                <ul>
                  <li><span>Use gate driver circuits with adequate protection features</span></li>
                  <li><span>Maintain recommended cooling</span></li>
                  <li><span>Include snubber and protection circuits</span></li>
                  <li><span>Avoid paralleling modules without proper current sharing mechanisms</span></li>
                </ul>

                <p><strong>The IGBT Module</strong> has become a cornerstone of modern power electronics. Its versatility, efficiency, and ability to handle high power make it indispensable across industries—from renewable energy to electric vehicles.</p>

                <p>If you're developing a product that requires efficient, reliable, and high-power switching, choosing the right IGBT module is not just a good idea—it's essential. With ongoing innovation in materials and packaging, the future for IGBT modules looks even brighter.</p>

                <p>Whether you're a designer, engineer, or tech enthusiast, understanding how IGBT modules work—and their capabilities—can help you build more robust and efficient systems.</p>

                <p><a href="/contact" className="wigm-red-link-plain">Contact us</a> for more info.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="wigm-bottom-row">
                <div className="wigm-bottom-nav">
                  <a href="/news/previous" className="wigm-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="wigm-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="wigm-share-icons">
                  <a href="#" className="wigm-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="wigm-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="wigm-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="wigm-sidebar">

              {/* Recent Posts */}
              <div className="wigm-sidebar-block">
                <p className="wigm-sidebar-title">Recent Posts</p>
                <div className="wigm-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="wigm-recent-item">
                      <img src={post.img} alt={post.title} className="wigm-recent-img" />
                      <div className="wigm-recent-body">
                        <span className="wigm-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="wigm-sidebar-block">
                <p className="wigm-sidebar-title">Social Media</p>
                <div className="wigm-social-icons">
                  <a href="#" className="wigm-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="wigm-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}